import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import Floor from "../../Services/floorServices";
import { Button, Popconfirm, Table, message } from "antd";
import USDFigure from "../../Components/USDFigure";
import AreaUnit from "../../Components/AreaUnit";
import TitleHeader from "../accounts/Components/TitleHeader";
import { permit } from "../../helpers/Authorize";
import { Delete, Edit } from "../../Components/Icons/Buttons";
import { userPermissions } from "../../config/EnVariables";
function FloorList(props) {
  const columns = [
    {
      title: "Floor Number",
      dataIndex: "floorNumber",
    },
    {
      title: "Area",
      dataIndex: "area",
    },
    {
      title: "Free Space",
      dataIndex: "freeSpace",
    },
    {
      title: "Unit Price",
      dataIndex: "feePerSquareMeter",
    },
    {
      dataIndex: "actions",
      title: "Action",
    },
  ];
  const navigate = useNavigate();
  const [floorList, setFloorList] = useState([]);
  const [loading, setLoading] = useState(false);

  const editFloor = (id) => {
    navigate(`/edit-floor/${id}`);
  };

  const deleteFloor = async (id) => {
    setLoading(true);
    await Floor.remove(id)
      .then(() => {
        setLoading(false);
        getFloorList();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getFloorList = async () => {
    setLoading(true);
    await Floor.getAllFloors()
      .then((data) => {
        setFloorList(data.data);
        console.log("FFFFFFFFFFFFFFFFLOORS", data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFloorList();
  }, []);
  return (
    <>
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="Floors List" />
          <div class="page-btn">
            <a href="add-floor" class="btn btn-added">
              <img src="/assets/img/icons/plus.svg" alt="img" class="me-2" />
              Add Floor
            </a>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>
              </div>

              <div class="card" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter User Name" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Phone" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Email" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <select class="select">
                          <option>Disable</option>
                          <option>Enable</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                      <div class="form-group">
                        <a class="btn btn-filters ms-auto">
                          <img
                            src="/assets/img/icons/search-whites.svg"
                            alt="img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Loader loading={loading} />
              <Table
                columns={columns}
                dataSource={floorList.map((item, index) => ({
                  key: index + 1,
                  floorNumber: item.floorNumber,
                  freeSpace: <AreaUnit area={item.freeSpace} />,
                  area: <AreaUnit area={item.area} />,
                  feePerSquareMeter: (
                    <USDFigure amount={item.feePerSquareMeter} />
                  ),
                  actions: (
                    <div>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => navigate(`/floor-details/${item.id}`)}
                      >
                        <img src="/assets/img/icons/eye.svg" alt="img" />
                      </button>
                      {permit(userPermissions.update) && (
                        <Edit onClick={() => editFloor(item.id)} />
                      )}

                      {permit(userPermissions.update) && (
                        <Popconfirm
                          title="Delete the Floor"
                          description="Are you sure to delete this Floor?"
                          onConfirm={() => deleteFloor(item.id)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Delete onClick={() => deleteFloor(item.id)} />
                        </Popconfirm>
                      )}
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FloorList;
